export type AddLeadFormSection =
  | typeof addLeadLeadSection
  | typeof addLeadAttributionSection
  | typeof addLeadLocationSection
  | typeof addLeadContactSection
  | typeof addLeadOwnerShipSection
  | typeof addLeadOtherSection
  | 'additionalInformationSection'
  // new sections
  | typeof addLeadLocationInfoSection
  | typeof addLeadFollowupInfoSection
  | typeof addLeadTargetPestsSection
  | typeof addLeadAssignmentSection
  | typeof addLeadMarketingAttributionSection

export type AddOppFormSection =
  | typeof addOpportunitySection
  | typeof addOpportunityFollowupInfoSection
  | typeof addOpportunityTargetPestsSection
  | typeof addOpportunityAssignmentSection
  | typeof addOpportunityMarketingAttributionSection

export type EntityFormFieldName =
  | typeof addLeadToPestPac
  | typeof addLeadFirstName
  | typeof addLeadLastName
  | typeof addLeadCompany
  | typeof addLeadAddress
  | typeof addLeadLocationTypeId
  | typeof addLeadDivisionId
  | typeof addLeadEmailAddress
  | typeof addLeadAltPhoneNumber
  | typeof addLeadPhoneNumber
  | typeof addLeadPreferredMethodOfContact
  | typeof addLeadPreferredTimeOfContact
  | typeof addLeadAssigneeId
  | typeof entitySalesTeamId
  | typeof entitySalesFunnelId
  | typeof addLeadSalesFunnelStageId
  | typeof entityLeadSourceId
  | typeof entityNextActionDate
  | typeof addLeadNote
  | typeof entityReferral
  | typeof entityTargetPests
  | typeof entityCampaignId
  | typeof addOppName
  | typeof addOppExpectedClosingDate
  | typeof addOppOwnerId
  | typeof addOppStageId
  | typeof addOppUseSystemName
  | typeof entityPreferredMethodOfContact
  | typeof entityPreferredTimeOfContact

export type AddLeadFormFieldManageRedirectNames = 'salesFunnelId'

export const addLeadToPestPac = 'addToPestPac'
export const addLeadFirstName = 'firstName'
export const addLeadLastName = 'lastName'
export const addLeadCompany = 'company'
export const addLeadAddress = 'address'
export const addLeadLocationTypeId = 'locationTypeId'
export const addLeadDivisionId = 'divisionId'
export const addLeadEmailAddress = 'emailAddresses'
export const addLeadPhoneNumber = 'phoneNumber'
export const addLeadAltPhoneNumber = 'altPhoneNumber'
export const addLeadPreferredMethodOfContact = 'preferredMethodOfContact'
export const addLeadPreferredTimeOfContact = 'preferredTimeOfContact'
export const entitySalesTeamId = 'salesTeamId'
export const addLeadAssigneeId = 'assigneeId'
export const entitySalesFunnelId = 'salesFunnelId'
export const entityReferral = 'referral'
export const entityCampaignId = 'campaignId'
export const entityLeadSourceId = 'leadSourceId'
export const entityNextActionDate = 'nextActionDate'
export const addLeadNote = 'note'
export const addNoteToPestPac = 'addNoteToPestPac'
export const noteCode = 'noteCode'
export const serviceLocation = 'serviceLocation'
export const addLeadSalesFunnelStageId = 'salesFunnelStageId'
export const entityTargetPests = 'targetPests'

export const addOppUseSystemName = 'useSystemName'
export const addOppName = 'opportunityName'
export const addOppOwnerId = 'ownerId'
export const addOppStageId = 'opportunityStageId'
export const addOppExpectedClosingDate = 'expectedClosingDate'

export const addLeadLeadSection = 'leadSection'
export const addLeadAttributionSection = 'attributionSection'
export const addLeadLocationSection = 'locationSection'
export const addLeadContactSection = 'contactSection'
export const addLeadOwnerShipSection = 'ownershipSection'
export const addLeadOtherSection = 'otherSection'

// new sections
export const addLeadLocationInfoSection = 'locationInfoSection'
export const addLeadFollowupInfoSection = 'followupInfoSection'
export const addLeadTargetPestsSection = 'targetPestsSection'
export const addLeadAssignmentSection = 'assignmentSection'
export const addLeadMarketingAttributionSection = 'marketingAttributionSection'

export const addOpportunitySection = 'opportunitySection'
export const addOpportunityFollowupInfoSection = 'followupInfoSection'
export const addOpportunityTargetPestsSection = 'targetPestsSection'
export const addOpportunityAssignmentSection = 'assignmentSection'
export const leadStatusDisqualified = 'Disqualified'
export const addOpportunityMarketingAttributionSection =
  'marketingAttributionSection'
export const entityPreferredMethodOfContact = 'preferredMethodOfContact'
export const entityPreferredTimeOfContact = 'preferredTimeOfContact'

export const addToPestPacOn = 1
export const addToPestPacOff = 0

export type IdLabelTupple = {
  id: string
  label: string
}

export const addLeadSectionLabels: Record<AddLeadFormSection, string> = {
  leadSection: 'Lead Information',
  attributionSection: 'Sales Attribution',
  locationSection: 'Location Information',
  contactSection: 'Contact Information',
  ownershipSection: 'Sales Ownership',
  otherSection: 'Other Information',
  additionalInformationSection: 'Additional Information',
  locationInfoSection: 'Location Information',
  followupInfoSection: 'Follow Up Information',
  targetPestsSection: 'Target Pest(s)',
  assignmentSection: 'Assignment',
  marketingAttributionSection: 'Marketing Attribution',
}

export const addOppSectionLabels: Record<AddOppFormSection, string> = {
  opportunitySection: 'Opportunity',
  followupInfoSection: 'Follow Up Information',
  targetPestsSection: 'Target Pest(s)',
  assignmentSection: 'Assignment',
  marketingAttributionSection: 'Marketing Attribution',
}

export const addLeadFieldNameLabels: Record<EntityFormFieldName, string> = {
  addToPestPac: 'Add to PestPac Upon Saving Leads',
  firstName: 'First Name',
  lastName: 'Last Name',
  company: 'Company Name',
  address: 'Address',
  locationTypeId: 'Location Type',
  divisionId: 'Division',
  emailAddresses: 'Email Address',
  phoneNumber: 'Phone',
  altPhoneNumber: 'Alternate Phone',
  preferredMethodOfContact: 'Best Contact Method',
  preferredTimeOfContact: 'Best Contact Time(s)',
  salesTeamId: 'Sales Team',
  assigneeId: 'Owner',
  salesFunnelId: 'Sales Funnel',
  salesFunnelStageId: 'Lead Status',
  campaignId: 'Campaign',
  leadSourceId: 'Lead Source',
  referral: 'Referral',
  targetPests: 'Target Pest(s)',
  nextActionDate: 'Next Action Date',
  note: 'Notes',
  opportunityName: 'Create Custom Name',
  useSystemName: 'Use System Name',
  opportunityStageId: 'Opportunity Stage',
  expectedClosingDate: 'Expected Closing Date',
  ownerId: 'Owner',
}
export const addLeadFieldNameManageUrl: Record<
  AddLeadFormFieldManageRedirectNames,
  string
> = {
  salesFunnelId: '/settings/salesFunnels',
}

export const systemOptionalFields: EntityFormFieldName[] = [
  'company',
  'firstName',
  'lastName',
  'emailAddresses',
  'phoneNumber',
]

export const emailAddressPhoneValidationMessage: string =
  'You must collect one of the two fields below: Email Address or Phone in order to add a lead into the system'

export const SourceFieldId: number = 6
export const CampaignFieldId: number = 9

export const leadSourceNoneId: string = '-1'
export const leadSourceNone: string = 'None'

export const campaignNone: string = 'None'

/**
 * Field ordering, card combining, display options, and validation messages
 * live in `config/registryData.ts`. They are private source data for the
 * field-settings registry, kept out of this file because everything exported
 * here is re-exported to the rest of the app.
 */

export const addToPestPacHeader = 'Add to PestPac upon saving'

export const addToPestPacSettingsHeader = 'Add to PestPac Upon Saving Lead'
export const addToPestFormField = 'createNewLocation'
export const locationUnder30PP = 'Address must be 30 characters or less'

export const addToPestPacFooter =
  'When On, Bill-to and Service Locations will automatically be created in PestPac upon saving new leads.'

export const hideRequiredValues = ['addToPestPac']

export const billToFieldNamePrefix = 'billTo_'

export enum EntityFormFieldNameEnums {
  AddToPestPac = addLeadToPestPac,
  DivisionId = addLeadDivisionId,
  EmailAddresses = addLeadEmailAddress,
  PhoneNumber = addLeadPhoneNumber,
  AltPhoneNumber = addLeadAltPhoneNumber,
  PreferredMethodOfContact = addLeadPreferredMethodOfContact,
  PreferredTimeOfContact = addLeadPreferredTimeOfContact,
  CampaignId = entityCampaignId,
  Referral = entityReferral,
  LocationTypeId = addLeadLocationTypeId,
  NextActionDate = entityNextActionDate,
  TargetPests = entityTargetPests,
  Note = addLeadNote,
  LeadSourceId = entityLeadSourceId,
  Address = addLeadAddress,
  FirstName = addLeadFirstName,
  LastName = addLeadLastName,
  Company = addLeadCompany,
  UseSystemName = addOppUseSystemName,
  OppName = addOppName,
  SalesTeamId = entitySalesTeamId,
  ExpectedClosingDate = addOppExpectedClosingDate,
  OppStageId = addOppStageId,
  SalesFunnelId = entitySalesFunnelId,
  OppOwnerId = addOppOwnerId,
}

export const addLeadFieldsToCheckNonRequiredErrors = [
  {
    name: EntityFormFieldNameEnums.DivisionId,
    errorFields: [
      'divisionId',
      'division',
      'billTo_divisionId',
      'billTo_division',
    ],
  },
  {
    name: EntityFormFieldNameEnums.EmailAddresses,
    errorFields: ['emailAddresses', 'billTo_emailAddresses'],
  },
  {
    name: EntityFormFieldNameEnums.PhoneNumber,
    errorFields: [
      'phoneNumber',
      'phoneExt',
      'billTo_phoneNumber',
      'billTo_phoneExt',
    ],
  },
  {
    name: EntityFormFieldNameEnums.AltPhoneNumber,
    errorFields: [
      'altPhoneNumber',
      'altPhoneExt',
      'billTo_altPhoneNumber',
      'billTo_altPhoneExt',
    ],
  },
  {
    name: EntityFormFieldNameEnums.PreferredMethodOfContact,
    errorFields: ['preferredMethodOfContact'],
  },
  {
    name: EntityFormFieldNameEnums.PreferredTimeOfContact,
    errorFields: ['preferredTimeOfContact'],
  },
  {
    name: EntityFormFieldNameEnums.CampaignId,
    errorFields: ['campaignId', 'campaign'],
  },
  { name: EntityFormFieldNameEnums.Referral, errorFields: ['referral'] },
  {
    name: EntityFormFieldNameEnums.LocationTypeId,
    errorFields: [
      'locationTypeId',
      'locationType',
      'billTo_locationTypeId',
      'billTo_locationType',
    ],
  },
  {
    name: EntityFormFieldNameEnums.NextActionDate,
    errorFields: ['nextActionDate'],
  },
  {
    name: EntityFormFieldNameEnums.TargetPests,
    errorFields: ['targetPests'],
  },
  {
    name: EntityFormFieldNameEnums.Note,
    errorFields: ['note', 'noteCode'],
  },
  {
    name: EntityFormFieldNameEnums.LeadSourceId,
    errorFields: ['leadSourceId', 'leadSource'],
  },
  {
    name: EntityFormFieldNameEnums.Address,
    errorFields: [
      'address1',
      'address2',
      'city',
      'state',
      'postalCode',
      'billTo_address1',
      'billTo_address2',
      'billTo_city',
      'billTo_state',
      'billTo_postalCode',
    ],
  },
  {
    name: EntityFormFieldNameEnums.FirstName,
    errorFields: ['firstName', 'billTo_firstName'],
  },
  {
    name: EntityFormFieldNameEnums.LastName,
    errorFields: ['lastName', 'billTo_lastName'],
  },
  {
    name: EntityFormFieldNameEnums.Company,
    errorFields: ['company', 'billTo_company'],
  },
]

export const addOppFieldsToCheckNonRequiredErrors = [
  {
    name: EntityFormFieldNameEnums.LeadSourceId,
    errorFields: ['leadSourceId', 'leadSource'],
  },
  {
    name: EntityFormFieldNameEnums.CampaignId,
    errorFields: ['campaignId', 'campaign'],
  },
  {
    name: EntityFormFieldNameEnums.Referral,
    errorFields: ['referral'],
  },
  {
    name: EntityFormFieldNameEnums.TargetPests,
    errorFields: ['targetPests'],
  },
  {
    name: EntityFormFieldNameEnums.NextActionDate,
    errorFields: ['nextActionDate'],
  },
  {
    name: EntityFormFieldNameEnums.UseSystemName,
    errorFields: ['useSystemName'],
  },
  {
    name: EntityFormFieldNameEnums.OppName,
    errorFields: ['opportunityName'],
  },
  {
    name: EntityFormFieldNameEnums.SalesTeamId,
    errorFields: ['salesTeamId'],
  },
  {
    name: EntityFormFieldNameEnums.ExpectedClosingDate,
    errorFields: ['expectedClosingDate'],
  },
  {
    name: EntityFormFieldNameEnums.OppStageId,
    errorFields: ['oppStageId'],
  },
  {
    name: EntityFormFieldNameEnums.SalesFunnelId,
    errorFields: ['salesFunnelId'],
  },
  {
    name: EntityFormFieldNameEnums.OppOwnerId,
    errorFields: ['oppOwnerId'],
  },
  {
    name: EntityFormFieldNameEnums.PreferredMethodOfContact,
    errorFields: ['preferredMethodOfContact'],
  },
  {
    name: EntityFormFieldNameEnums.PreferredTimeOfContact,
    errorFields: ['preferredTimeOfContact'],
  },
  {
    name: EntityFormFieldNameEnums.Note,
    errorFields: ['note'],
  },
]
